/* @flow */

import { callApiEndpoint } from './index';

import utils from './utils';

import type { Category } from 'types';

const find = async (): Promise<Category[]> => {
  const response = await callApiEndpoint('categorie/findAll', { method: 'POST', body: {} });
  return response.map(utils.toCategory);
};

export default {
  find,
};
